//src/pages/SorteadorLogin.jsx

import React, { useEffect, useState } from "react";
import axios from "../axiosConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { LockKeyhole, LogIn, Sparkles } from "lucide-react";
import "./SorteadorLogin.css";

function SorteadorLogin() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const slugInicial = params.get("slug") || "";

  const [slug, setSlug] = useState(slugInicial);
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("sorteador_token");
    const sorteioSlug = sessionStorage.getItem("sorteador_slug");

    if (token && sorteioSlug) {
      navigate(`/sorteador/${sorteioSlug}/ao-vivo`);
    }
  }, [navigate]);

  const entrar = async (e) => {
    e.preventDefault();
    setMensagem("");

    if (!slug.trim() || !senha.trim()) {
      setMensagem("Informe o slug do sorteio e a senha do apresentador.");
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.post("/sorteador/login", {
        slug: slug.trim(),
        senha
      });

      sessionStorage.setItem("sorteador_token", data.token);
      sessionStorage.setItem("sorteador_slug", data.sorteio.slug);
      sessionStorage.setItem("sorteador_titulo", data.sorteio.titulo);

      navigate(`/sorteador/${data.sorteio.slug}/ao-vivo`);
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível acessar o sorteador."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sorteadorLogin-page">
      <div className="sorteadorLogin-card">
        <div className="sorteadorLogin-logoBox">
          <img src="/logo2.png" alt="Tikpag" />
        </div>

        <div className="sorteadorLogin-icon">
          <Sparkles size={30} />
        </div>

        <span className="sorteadorLogin-kicker">Acesso do apresentador</span>

        <h1>Sorteador Tikpag</h1>

        <p>
          Entre com o slug e a senha do sorteio para abrir a tela ao vivo sem
          acessar o painel administrativo.
        </p>

        <form onSubmit={entrar} className="sorteadorLogin-form">
          <label>
            <span>Slug do sorteio</span>
            <input
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              placeholder="evento-tikpag"
            />
          </label>

          <label>
            <span>Senha do apresentador</span>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Digite a senha"
            />
          </label>

          {mensagem && (
            <div className="sorteadorLogin-message">
              <LockKeyhole size={16} />
              {mensagem}
            </div>
          )}

          <button type="submit" disabled={loading}>
            <LogIn size={18} />
            {loading ? "Entrando..." : "Entrar no sorteador"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SorteadorLogin;